import * as a from '@mitranim/js/all.mjs'
import * as c from './conf.mjs'

export function isDivisibleBy(divisible, divisor) {
  a.reqFin(divisible)
  a.reqFin(divisor)
  return (divisible % divisor) === 0
}

export function moneyCentsToUnits(cents) {
  if (a.isNil(cents)) return cents
  a.reqFin(cents)
  return cents / c.CENTS_IN_UNIT
}

export function moneyUnitsToCents(amount) {
  if (a.isNil(amount)) return amount
  a.reqFin(amount)
  return amount * c.CENTS_IN_UNIT
}

/*
Sandwiches the number between two bounds. If the lower bound is greater than the
upper bound, the behavior is undefined.
*/
export function boundedNum(value, lower, upper) {
  value = a.laxFin(value)
  a.reqFin(lower)
  a.reqFin(upper)
  return Math.min(upper, Math.max(lower, value))
}

export function rndIntIncl(min, max) {
  a.reqNat(min)
  a.reqNat(max)
  return Math.trunc(Math.random() * (max - min + 1)) + min
}

// Truncates the number to N decimal places, towards zero.
export function truncTo(num, decimalPlaces) {
  a.reqFin(num)
  a.reqNat(decimalPlaces)

  const coeff = Math.pow(10, decimalPlaces)
  return Math.trunc(num * coeff) / coeff
}

// Fractional part of a number, like `0.2` from `1.2`.
export function fraction(num) {
  a.reqFin(num)
  return num - Math.trunc(num)
}

// See `test_ceilDecimal`.
export function ceilDecimal(src) {
  src = a.laxFin(src)
  const scale = Math.pow(10, Math.trunc(Math.log10(Math.abs(src)))) | 0
  return scale && (scale * ceil(src / scale))
}

// Inverse of `Math.trunc`.
export function ceil(src) {
  src = a.laxFin(src)
  return src < 0 ? Math.floor(src) : Math.ceil(src)
}

export function percentInverse(val) {
  return 100 - a.laxFin(val)
}

// TODO rename to `toNotNeg`.
export function toNat(val) {return Math.max(0, a.optFin(val))}

// TODO move to `@mitranim/js`.
export function bitsHas(src, mask) {return !!(a.laxNat(src) & a.reqNat(mask))}
export function bitsAdd(src, mask) {return a.laxNat(src) | a.reqNat(mask)}
export function bitsDel(src, mask) {return a.laxNat(src) & ~a.reqNat(mask)}

export function avg(src) {return a.values(src).reduce(avgAdd, 0)}

function avgAdd(acc, num, ind) {
  return !a.isFin(num) ? acc : acc + ((num - acc) / (ind + 1))
}

// Non-insane variant of `Math.round`. Rounds away from 0, instead of up.
export function round(val) {
  a.optNum(val)
  if (a.isNil(val) || a.isNaN(val) || a.isInf(val)) return val
  if (val < 0) return -Math.round(-val)
  return Math.round(val)
}
